export default "__VITE_ASSET__mefaN8lt__"